import Tabs, { TabsItemProps } from 'components/common/tabs';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import TourCardDetail from './tour-card-detail';
import TourFlightCard from './tour-flight-card';
import TourHotelCard from './tour-hotel-card';
import TourProductCard from './tour-product-card';

export default function TourDetail() {
  const { t } = useTranslation();
  const [activeKey, setActiveKey] = React.useState<React.Key>('0');

  const render = React.useCallback(() => {
    switch (activeKey) {
      case '0':
        return <TourCardDetail />;
      case '1':
        return <TourFlightCard />;
      case '2':
        return <TourHotelCard />;
      case '3':
        return <TourProductCard />;
    }
  }, [activeKey]);

  return (
    <>
      <Tabs
        activeKey={activeKey}
        onChangeActive={({ activeKey }) => {
          setActiveKey(activeKey);
        }}
        items={
          [
            {
              title: t('common:tour_details'),
              component: <></>,
            },
            {
              title: t('common:flight'),
              component: <></>,
            },
            {
              title: t('common:hotel'),
              component: <></>,
            },
            {
              title: t('common:product'),
              component: <></>,
            },
          ].filter(Boolean) as TabsItemProps[]
        }
        overrideStyles={{
          tabList: { minHeight: '0px' },
          tab: { minHeight: '0px', height: '0', flexGrow: '0' },
          tabPanel: { minHeight: '0px', height: '0', flexGrow: '0' },
        }}
      />
      <div>{render()}</div>
    </>
  );
}
